var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCellphone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.05,
    height: 26.667,
    viewBox: "-0.017 0.75 27.05 26.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.506 3.95C.28 4.349.208 4.743.263 5.12c-.238.92-1.75 8.011 6.41 15.91 8.285 8.018 15.126 6.406 16.124 5.89.374.04.761-.054 1.15-.285.774-.458 2.11-1.603 2.63-2.255.738-.916.523-1.57-.345-2.164l-6.193-4.236c-.621-.424-1.447-.272-1.855.295l-1.608 2.277a1.03 1.03 0 0 0-.178.455c-.217.124-2.274 1.154-6.104-2.674-3.934-3.929-4.32-5.85-3.883-7.025.148-.036.291-.094.417-.192L9.05 9.436c.56-.423.677-1.26.237-1.866L4.847 1.515c-.618-.841-1.278-1.04-2.173-.27C2.042 1.786.943 3.16.506 3.95Z",
    fill: "#357fd8",
    fillRule: "evenodd",
    "data-name": "Path 74"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCellphone);
export default __webpack_public_path__ + "static/media/cellphone.0a9a45102d402dfe65753f4babaa0ddb.svg";
export { ForwardRef as ReactComponent };